
import React, {Component} from 'react';
import {Button,Modal,ButtonToolbar} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import {connect} from 'react-redux'
class ExportExcelModal extends Component {

  constructor(...args){
    super(...args)
    this.refTableId = 'export-stock-'+Math.ceil(Math.random()*100);
    let data = []
    if (process.env.NODE_ENV === "development") {
      //data = [{itemnum:1,detail:"test",productcode:'abc',quantity:'10'}]
    }
    this.state = {show:false,data:data,oneFill:false}
  }
  
  clearItem(){
    this.setState({data:[]}) 
  }

  addItem(nItem){
    let {data} = this.state
    
    let foundItem = false
    data.map((item,index)=>{
      if(item.itemnum===nItem.itemnum){
        foundItem = true
      }
      return item
    })
    if(!foundItem)
      data.push(nItem)
    this.setState({data:data})    
  }

  removeItem(rItem){
    let {data} = this.state
    data = data.reduce((rresult,item)=>{
      if(item.itemnum!==rItem.itemnum){
        rresult.push(item)
      }
      return rresult
    },[])
    this.setState({data:data})
  }

  onClick(){
    this.setState({show:true})
  }

  onHide(){
    this.setState({show:false})    
  }

  onTextChange(index,key,e){
    let {data} = this.state
    data[index][key] = {value:e.target.value}
    this.setState({data:data})
  }

  onTextBlur(index,key,colValue){
    let {data} = this.state
    data[index][key] = colValue.value
    this.setState({data:data})
  }

  onColumnClick(index,key,colValue){
    let {data} = this.state
    let value = (typeof colValue.value !=='undefined')?colValue.value:colValue   
    data[index][key] = {value:value}
    this.setState({data:data})
  }

  onOKClick(){
    this.setState({show:false})   
    
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    // let wb = new Workbook()
    // wb.SheetNames.push('worksheet')
    // wb.Sheets['worksheet'] = worksheet
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    let {messages} = this.props
    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), messages['Warehouse List']+".xlsx")
  
  }

  onDeleteClick(index,e){
    let {data} = this.state
    data.splice(index,1)
    this.setState({data:data})
  }

  onOneCheckbox(e,value){
    let {data} = this.state
    data = data.map((item,index)=>{
      if(value){
        if(item.quantity*1===0){
          item['preQuantity'] = item.quantity
          item.quantity = 1        
        }
      }else{
        item.quantity = item.preQuantity
      }
      return item
    })
    this.setState({data:data,oneFill:value})
  }

  

  renderInputColumn(item,index,key){
    if(item!==null && item!=='' && typeof item.value !=='undefined')
      return (<input autoFocus
        style={{display:'inline-block'}}
        className='form-control text-left'
        value={item.value}
        onBlur={ this.onTextBlur.bind(this,index,key,item) }
        onChange={ this.onTextChange.bind(this,index,key) }
      />)
    return (
      <div>{item}</div>
    )
  }

  renderRowData(){
    let {data,headerTitles,messages} = this.props
    if(data.length===0){
      return (<tr><td colSpan={headerTitles.length}>{messages['No Item']}</td></tr>)
    }
    return data.map((row, index) => {
      
      const tds = headerTitles.map((item,cid)=>{
        if(row[item.field]!==undefined)
          return <td key={100+cid} >{row[item.field]}</td>
        else
          return <td key={100+cid} >{'!Error'}</td>
      })
      return <tr key={index} >{tds}</tr>
    })
  }

  renderRowHeader(item,i){
    return(
      <th key={i} className='text-center bg-blue-print' >
        {item.title}
      </th>
    )
  }

  renderHeaderCustom(headers) {
    const ths = headers.map((item, i) => (
      this.renderRowHeader(item,i)
    ))

    return (
      <thead>
        <tr>
          {ths}
        </tr>
      </thead>
    )
  }

  renderTable(){
    let {headerTitles} = this.props
    return (
      <div className='display-overflow' style={{height:'100%'}}>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid'>
          {this.renderHeaderCustom(headerTitles)}
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderDeleteTable(){
    let {data} = this.state
    let {messages} = this.props
    return (
      <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item,index)=>(
            <tr key={index}>
              <td><Button bsStyle={'danger'} onClick={this.onDeleteClick.bind(this,index)}>{messages['Delete']}</Button></td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  render(){
    let {show,messages} = this.props
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="fullwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{messages['Download Excel File']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
              <div style={{height:(window.innerHeight-160)+'px'}}>              
                {this.renderTable()}              
              </div>
                     
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='primary' onClick={this.onOKClick.bind(this)}><FontAwesome name='download'/>&nbsp;{messages['Download File']}</Button>
            <Button onClick={this.props.onHide}><FontAwesome name='close'/>&nbsp;{messages['Cancel']}</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>  
    )
  }

  
}

ExportExcelModal.defaultProps = {
  show :false,
  messages : {'Cancel':'ยกเลิก','Download File':'ดาวน์โหลด','Download Excel File':'ดาวน์โหลดเอ็กเซลไฟล์'},
  data:[],
  headerTitles:[],
  excludedColumns:[]
}

export default connect(
  (state) => ({messages: state.message.component.ExportExcelModal}),null,null,{withRef:true},
)(ExportExcelModal);





// WEBPACK FOOTER //
// ./src/component/ExportExcelModal.js